import { Platform } from '@ionic/angular';
import { currencyCode, imageUrl } from './../../../environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserInfo } from 'src/app/stores/authentication.store';
import { PaymentMethod, WalletStore } from 'src/app/stores/wallet.store';

@Component({
  selector: 'app-payment-option',
  templateUrl: './payment-option.component.html',
  styleUrls: ['./payment-option.component.scss'],
})
export class PaymentOptionComponent implements OnInit {
  @Input() paymentMethodList: PaymentMethod;
  @Input() userInfo;
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  constructor(public translate: TranslateService, public Platform: Platform) {}

  ngOnInit() {}
}
